import React, { FC } from 'react';
import styled from 'styled-components';
import { TextArea } from 'components/atoms/input';
import { useInput } from 'hooks/use-input';

interface Props {
  onChange: (value: string, e: React.FocusEvent<HTMLInputElement>) => void;
  initialValue?: string;
}
const StyledTextArea = styled(TextArea)`
  border: none;
  background: transparent;
  &:focus {
    background-color: var(--gray-10);
    border-bottom: 1px solid var(--gray-50);
  }
`;

export const MultiLineInputTextField: FC<Props> = (props) => {
  const { initialValue = '', onChange } = props;

  const [value, onInputChange] = useInput(initialValue);

  const handleOnBlur = (e) => {
    onChange(value, e);
  };

  return (
    <StyledTextArea
      placeholder="—"
      value={value}
      onChange={onInputChange}
      onBlur={handleOnBlur}
      autoSize={{
        minRows: 1,
        maxRows: 5,
      }}
    />
  );
};
